export default __webpack_public_path__ + "static/media/vc-flag-vn.10d8186f.png";